import { map } from 'rxjs/operators/map';
import { GatewaySerializer } from '../../models';
import ajax from '../../utils/ajax';

class GatewayService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPath = '/networkAsset/airfinder/status';
  configurationPathGroup = '/networkAsset/airfinder/status/gateways';
  deleteConfigurationPath = '/networkAsset/airfinder/status/gateway';

  getAll = (siteId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.configurationPathGroup
        }?siteId=${siteId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(
      map(data => {
        let serializedResponse =
          data &&
          data.response.map(dataResponse => {
            dataResponse = GatewaySerializer.normalize(dataResponse);
            return dataResponse;
          });
        serializedResponse.sort((a, b) => a.healthPriority - b.healthPriority);
        return serializedResponse;
      })
    );
  };
  deleteSiteGateway = (siteId, nodeAddress, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.deleteConfigurationPath
        }/${nodeAddress}?siteId=${siteId}`,
        method: 'DELETE',
        responseType: 'json'
      },
      store
    );
  };
}
export default new GatewayService();



// WEBPACK FOOTER //
// ./src/services/gatewayservice/index.js